import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Logo from "../../assets/logoN3_transparent.png";
import { useEffect } from "react";
import firebase from "../../utils/firebase";
import { useHistory } from "react-router-dom";
import { logoutSuccess, setIsDrawer } from "../../redux/reducers/auth.reducer";
import { styled, alpha, useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LogoutOutlined from "@mui/icons-material/LogoutOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import "./styles.css";
import {
  CloseOutlined,
  Storefront,
  NotificationsActive,
} from "@mui/icons-material/";
import MoreIcon from "@mui/icons-material/MoreVert";
import CssBaseline from "@mui/material/CssBaseline";
import {
  setSearchText,
  clearSearchText,
} from "../../redux/reducers/search.reducer";
import TextField from "@mui/material/TextField";
import { FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import { t } from "i18next";
import { emptyIfNull } from "../../utils/methods.utils";
import { setFavouriteProducts } from "../../redux/reducers/favouriteProducts.reducer";
import {
  setNotifications,
  setNotificationsProducts,
} from "../../redux/reducers/notificationsProducts.reducer";
import {
  setSelectedEmirates,
  setSelectedRegion,
} from "../../redux/reducers/emiratesAndRegion.reducer";
import { setSelectedStores } from "../../redux/reducers/stores.reducer";
import NotificationItem from "../../components/notifications/notificationItem";
import { isMobile } from "react-device-detect";
const drawerWidth = 240;
const Image = styled("img")(({ theme }) => ({
  width: 100,
  height: 80,
  resizeMode: "contain",
}));

const Search = styled("form")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  display: "flex",
  flex: 1,
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(TextField)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

const NavBar = ({ handleDrawerChange, mobileOpen, handleDrawerToggle }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  // const [mobileOpen, setMobileOpen] = React.useState(false);
  const userData = useSelector((state) => state.auth.user);
  const userNotifications = useSelector(
    (state) => state.notificationsProducts.notifications
  );
  const cart = useSelector((state) => state.cart);
  const searchText = useSelector((state) => state.searchMode.text);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationAnchorEl, setNotificationAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(
    isMobile ? false : true
  );
  const [search, setSearch] = React.useState(searchText);
  const theme = useTheme();
  const isMenuOpen = Boolean(anchorEl);
  const isNotificationMenuOpen = Boolean(notificationAnchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleNotificationMenuClose = () => {
    setNotificationAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleNotificationMenuOpen = (event) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleLogout = async () => {
    await firebase.auth().signOut();
    dispatch(logoutSuccess());
    dispatch(setFavouriteProducts([]));
    dispatch(setSelectedEmirates([]));
    dispatch(setSelectedRegion([]));
    dispatch(setNotificationsProducts([]));
    dispatch(setNotifications([]));
    dispatch(setSelectedStores([]));
  };

  useEffect(() => {
    setSearch(searchText);
  }, [searchText]);

  const notificationMenuId = "primary-search-notification-menu";
  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {!userData?.isAnonymous && (
        <MenuItem onClick={() => history.push("/profile")}>My account</MenuItem>
      )}
      <MenuItem onClick={handleLogout}>Logout</MenuItem>
    </Menu>
  );
  const renderNotificationMenu = (
    <Menu
      anchorEl={notificationAnchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      id={notificationMenuId}
      keepMounted
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      open={isNotificationMenuOpen}
      onClose={handleNotificationMenuClose}
    >
      {userNotifications &&
        userNotifications.length > 0 &&
        userNotifications.map((notification) => (
          <NotificationItem notification={notification} />
        ))}
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile-whizz";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={() => history.push("/stores")}>
        <IconButton
          size="large"
          aria-label={`show ${
            cart?.numberOfProducts ?? 0
          } comparing cart items`}
          color="inherit"
        >
          <Storefront />
        </IconButton>
        <p>Super Markets</p>
      </MenuItem>
      <MenuItem
        onClick={() => {
          history.push("/comparing-cart");
        }}
      >
        <IconButton
          size="large"
          aria-label={`show ${
            cart?.numberOfProducts ?? 0
          } comparing cart items`}
          color="inherit"
        >
          {!!cart?.numberOfProducts && cart?.numberOfProducts > 0 && (
            <Badge badgeContent={cart?.numberOfProducts ?? 0} color="error">
              <ShoppingCartIcon />
            </Badge>
          )}
        </IconButton>
        <p>Comparing Cart</p>
      </MenuItem>

      {userData?.isAnonymous && (
        <MenuItem onClick={handleLogout}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
          >
            <LogoutOutlined />
          </IconButton>
        </MenuItem>
      )}
      {!userData?.isAnonymous && (
        <MenuItem onClick={handleProfileMenuOpen}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
          <p>Profile</p>
        </MenuItem>
      )}
    </Menu>
  );
  return (
    <Box style={{ display: "flex", marginBottom: "8%" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
        style={{ backgroundColor: "whitesmoke" }}
      >
        <Toolbar style={{ backgroundColor: "whitesmoke" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            sx={{
              display: { xs: "block", sm: "none" },
            }}
            variant="h6"
            noWrap
            component="div"
          >
            <IconButton
              sx={{ mr: 2, maxHeight: 80 }}
              size="medium"
              onClick={() => history.replace("/")}
            >
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{ display: { xs: "block", sm: "block" } }}
              >
                <Image
                  alt={"logo"}
                  src={Logo}
                  style={{ width: 100, height: 100 }}
                />
              </Typography>
            </IconButton>
          </Typography>
          {/* <IconButton
            size="large"
            edge="start"
            color="inherit"
            onClick={() => {
              handleDrawerChange(!isDrawerOpen);
              dispatch(setIsDrawer(!isDrawerOpen));
              setIsDrawerOpen(!isDrawerOpen);
            }}
            aria-label="open drawer"
            sx={{ mr: 2 }}
          >
            {isDrawerOpen ? (
              <CloseOutlined style={{ color: "#fac904" }} />
            ) : (
              <MenuIcon style={{ color: "#fac904" }} />
            )}
          </IconButton> */}
          {mobileOpen && (
            <IconButton
              sx={{ mr: 2, maxHeight: 80 }}
              size="medium"
              onClick={() => history.replace("/")}
            >
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{ display: { xs: "block", sm: "block" } }}
              >
                <Image
                  alt={"logo"}
                  src={Logo}
                  style={{ width: 100, height: 100 }}
                />
              </Typography>
            </IconButton>
          )}
          <FormControl
            sx={{ display: { xs: "none", md: "flex" } }}
            style={{ flex: 1 }}
            variant="outlined"
          >
            <OutlinedInput
              id="outlined-adornment-password"
              type={"text"}
              value={search}
              onChange={(value) => {
                dispatch(setSearchText(emptyIfNull(value.target.value)));
              }}
              placeholder={t("home.search")}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Clear"
                    onClick={() => {
                      setSearch("");
                      dispatch(clearSearchText());
                    }}
                    edge="end"
                  >
                    <ClearIcon style={{ color: "#fac904" }} />
                  </IconButton>
                </InputAdornment>
              }
              startAdornment={
                <InputAdornment position="start">
                  <IconButton aria-label="Search" edge="start">
                    <SearchIcon color={theme.light.primary} />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <Box sx={{ flexGrow: 1 }} />
          {!userData?.isAnonymous && (
            <Box sx={{ display: { xs: "flex", md: "flex" } }}>
              <IconButton
                onClick={handleNotificationMenuOpen}
                size="large"
                aria-controls={notificationMenuId}
                aria-label={`show ${
                  userNotifications?.map((item) => !item?.isOpened)?.length ?? 0
                } notifications`}
                color="inherit"
              >
                <Badge
                  badgeContent={
                    userNotifications?.map((item) => !item?.isOpened)?.length ??
                    0
                  }
                  color="error"
                >
                  <NotificationsActive
                    color="#fac904"
                    style={{ color: "#fac904" }}
                  />
                </Badge>
              </IconButton>
            </Box>
          )}
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <IconButton
              onClick={() => {
                history.push("/comparing-cart");
              }}
              size="large"
              aria-label={`show ${
                cart?.numberOfProducts ?? 0
              } comparing cart items`}
              color="inherit"
            >
              <Badge badgeContent={cart?.numberOfProducts ?? 0} color="error">
                <ShoppingCartIcon
                  color="#fac904"
                  style={{ color: "#fac904" }}
                />
              </Badge>
            </IconButton>
          </Box>

          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <IconButton
              onClick={() => {
                history.push("/stores");
              }}
              size="large"
              aria-label={`markets`}
              color="inherit"
            >
              <Storefront color="#fac904" style={{ color: "#fac904" }} />
            </IconButton>

            {!userData?.isAnonymous && (
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle style={{ color: "#fac904" }} />
              </IconButton>
            )}
            {userData?.isAnonymous && (
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleLogout}
                color="inherit"
              >
                <LogoutOutlined style={{ color: "#fac904" }} />
              </IconButton>
            )}
          </Box>

          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            {!userData?.isAnonymous && (
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon style={{ color: "#fac904" }} />
              </IconButton>
            )}
            {userData?.isAnonymous && (
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleLogout}
                color="inherit"
              >
                <LogoutOutlined style={{ color: "#fac904" }} />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      {/* <ResponsiveDrawer /> */}
      {/* <ResponsiveDrawer
        isDrawerOpen={isDrawerOpen}
        toggleDrawer={(value) => {handleDrawerChange(value);dispatch(setIsDrawer(!isDrawerOpen));setIsDrawerOpen(value);}}
      /> */}
      {renderMobileMenu}
      {renderMenu}
      {!userData?.isAnonymous && renderNotificationMenu}
    </Box>
  );
};

export default NavBar;
